import React, { useState, useCallback, useEffect } from "react";
import styles from "./style.module.css";
import bullet from "../../../assets/images/bullet.svg";
import Icon_L from "../../../assets/images/Icon_L.svg";
import { Toaster } from "react-hot-toast";
import * as toast from "../../../utils/makeToast";
import success from "../../../assets/images/success-icon.svg";
import axios from "axios";
import { baseBusinessUrl } from "../../../utils/baseUrl";
import { useNavigate } from "react-router-dom";
import dash from "../../../assets/icons/dash.svg";
import Download from "../../../assets/icons/Download.svg";
import whatsapp from "../../../assets/icons/whatsapp.svg";
import email from "../../../assets/icons/email.svg";
import uploadArrow from "../../../assets/images/upload-arrow.svg";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../../redux/accountOpening";
import { encryptRequest } from "../../../utils/encryption";
import SuccessIcon from "../../../assets/icons/SuccessIcon";

export default function NewAddReference(universalID) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [accountNumber, setAccountNumber] = useState("");
  const [secondAccountNumber, setSecondAccountNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [referenceSet, setReferenceSet] = useState(true);
  const [showReference, setShowReference] = useState(true);
  const [showBanks, setShowBanks] = useState(false);
  const [sterlingBank, setSterlingBank] = useState(false);
  const [main, setMain] = useState(true);
  const [refereeSuccess, setRefereeSuccess] = useState(false);
  const [refrenceAdded, setRefrenceAdded] = useState(false);
  const [banks, setBanks] = useState<any[]>([]);
  const [showOtherBanks, setShowOtherBanks] = useState(false);
  const [otherBanks, setOtherBanks] = useState("");
  const [goBack, setGoBack] = useState(false);
  const [otherBankReference, setOtherBankReference] = useState(false);
  const [referenceAddedModal, setReferenceModal] = useState(false);
  const [secondReferenceComponenet, setSecondReferenceComponent] =
    useState(false);

  const [secondAccountNumberBanks, setSecondAccountNumberBanks] =
    useState(false);

  const clickShowSecondReferenceComponent = () => {
    setRefrenceAdded(false);
    setSecondReferenceComponent(true);
    setSecondAccountNumberBanks(true);
  };

  const clickOtherBanksProceed = () => {
    setReferenceModal(true);
  };

  const proceedFromOtherBanks = () => {
    setSecondReferenceComponent(false);
    setOtherBankReference(true);
    setShowOtherBanks(false);
  };

  const submitBusinessReferee = () => {
    let businessRefereePayload = {
      refereeAccountNumber: accountNumber,
      refereeFormUrl: certificateOfRegistration,
      id: universalID,
    };
    setLoading(true);

    axios
      .post(
        `${baseBusinessUrl}BusinessAccount/BusinessReferee`,
        businessRefereePayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.message);
          setRefereeSuccess(true);
          setRefrenceAdded(true);
          setShowReference(false);
          setSterlingBank(false);
        } else {
          toast.errorToast(response.data.message);
        }

        setLoading(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setLoading(false);
        setRefereeSuccess(true);
        setRefrenceAdded(true);
        setShowReference(false);
        setSterlingBank(false);
      });
  };

  const submitOtherBusinessReferee = () => {
    let businessRefereePayload = {
      refereeAccountNumber: accountNumber,
      refereeFormUrl: certificateOfRegistration,
      id: 1,
    };
    setLoading(true);

    axios
      .post(
        `${baseBusinessUrl}BusinessAccount/BusinessReferee`,
        businessRefereePayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.message);
          setReferenceModal(true);
        } else {
          toast.errorToast(response.data.message);
        }

        setLoading(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setLoading(false);
      });
  };

  const getBanks = () => {
    axios
      .get(`${baseBusinessUrl}Enum/BanksList`)
      .then((response) => {
        setBanks(response.data);
      })
      .catch((err) => {
        
      })
      // REMOVE THE FINALLY BLOCK BELOW
      .finally(() => {
        setBanks([
          {
            id: 1,
            name: "Access Bank",
          },
          {
            id: 2,
            name: "Stanbic IBTC",
          },
        ]);
      });
  };

  useEffect(() => {
    getBanks();
  }, []);

  const validateAccountNumber = useCallback(() => {
    setLoading(true);

    axios
      .get(
        `${baseBusinessUrl}Authentication/ValidationAccountNumber?accountnumber=${encryptRequest(
          accountNumber
        )}`
      )
      .then((response) => {
        
        if (response.data.message === "Valid Account Number") {
          toast.successToast(response.data.message);
          // setRefrenceAdded(true);
          setShowBanks(true);
          setShowReference(false);
          setLoading(false);
        } else {
          toast.errorToast("Invalid Account Number");
          setLoading(false);
        }
      })
      .catch((err) => {
        
        toast.errorToast("Invalid Account Number");
        setLoading(false);
      });
  }, [accountNumber]);

  const validateSecondAccountNumber = useCallback(() => {
    setLoading(true);

    axios
      .get(
        `${baseBusinessUrl}Authentication/ValidationAccountNumber?accountnumber=${encryptRequest(
          secondAccountNumber
        )}`
      )
      .then((response) => {
        
        if (response.data.message === "Valid Account Number") {
          toast.successToast(response.data.message);
          // setRefrenceAdded(true);
          setSecondAccountNumberBanks(false);

          setShowReference(false);
          setLoading(false);
        } else {
          toast.errorToast("Invalid Account Number");
          setLoading(false);
        }
      })
      .catch((err) => {
        
        toast.errorToast("Invalid Account Number");
        setLoading(false);
      });
  }, [secondAccountNumber]);

  const addReference = () => {
    setReferenceSet(false);
  };

  const clickSterlingBank = () => {
    setSterlingBank(true);
    setShowBanks(false);
    setMain(false);
    setSecondReferenceComponent(false);
  };

  const clickOtherBanks = () => {
    setShowOtherBanks(true);
    setShowBanks(false);
    setMain(false);
    setGoBack(false);
    setSecondReferenceComponent(false);
  };

  const clickGoback = () => {
    setShowBanks(false);
    setShowBanks(false);
    setGoBack(true);
  };

  const routeBackHome = useCallback(() => {
    setRefereeSuccess(false);
    navigate("/");
    setSterlingBank(false);
  }, [navigate]);

  const addSecondReference = useCallback(() => {
    setRefereeSuccess(false);
    setShowReference(false);
    setSterlingBank(false);
  }, []);

  const handleChange = (event: any) => {
    setOtherBanks(event.target.value);
  };

  const changeReferee = () => {
    dispatch(setAccountOpeningStep("success-business-account"));
  };

  let fileUploadObj: any;

  const [certificateOfRegistration, setCertificateOfRegistration] =
    useState("");
  const [showCertificateOfRegistration, setShowCertificateOfRegistration] =
    useState(false);

  const uploadImage = (payload: any, type: string) => {
    

    if (type === "certificateOfResgistration") {
      
      setShowCertificateOfRegistration(true);
      setCertificateOfRegistration(payload.postedFilebase64);
    }
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let base64: any;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      

      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }

    convertToBase64(file).then((res) => {
      
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleSubmit(type);
    });
  };
  return (
    <div>
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      {refereeSuccess && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <SuccessIcon/>
            <h3>
              <b>Reference added successfully</b>
            </h3>
            <p>
              We have contacted your Sterling Referee, and we await their
              consent. You will be notified if no response is received within
              24hrs.
            </p>
            <p>
              Confirmation commences immediately after consent has been received
              and is completed within 1-2 working days. You will be notified of
              the outcome.
            </p>
            <div className={styles.ErrorButtonFlex}>
              <button className={styles.ErrorCancel} onClick={routeBackHome}>
                Okay
              </button>
              {secondAccountNumber?.length > 0 ? null : (
                <button
                  className={styles.ErrorRetry}
                  onClick={addSecondReference}
                >
                  Add second reference
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {referenceAddedModal && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <SuccessIcon/>
            <h2>
              <b>Reference added successfully</b>
            </h2>
            <p>
              We are currently reviewing the reference form and we will contact
              your referee’s bank. Confirmation may take up to 3 working days
              and you will be notified of the outcome.
            </p>

            <div className={styles.ErrorButtonFlex}>
              <button className={styles.ErrorCancel} onClick={routeBackHome}>
                Okay
              </button>
            </div>
          </div>
        </div>
      )}

      {otherBankReference && (
        <div className={styles.otherBankReferenceContainer}>
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">Add reference</h4>
            <p className={styles.paragraphx}>
              Download or email the reference form to refree and upload the
              completed form. <span>See preview</span>
            </p>
          </div>
          <p>Share or download</p>
          <div className={styles.iconFlexSvg}>
            <img src={Download} alt="" />
            <img src={whatsapp} alt="" />
            <img src={email} alt="" />
          </div>
          <div className={styles.documentUpload}>
            <p className={styles.upload}>Upload completed form</p>
            <div>
              <div className="col-md-6 mt-2">
                <div className="col-md-6">
                  <label
                    className="cursor-pointer"
                    htmlFor="parentofCertificateOfResgistration"
                  >
                    <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                      {showCertificateOfRegistration ? (
                        <p className="label_text">form Uploaded</p>
                      ) : (
                        <p className="label_text">
                          Click or drag <br /> and drop file
                        </p>
                      )}

                      <img className="img-fluid" src={uploadArrow} alt="" />
                    </div>
                    <input
                      onChange={(e) =>
                        handleFileUpload(e, "certificateOfResgistration")
                      }
                      id="parentofCertificateOfResgistration"
                      className="input-file-type"
                      type="file"
                      name="file"
                      accept="image/png, image/jpg, image/jpeg"
                    />
                  </label>
                </div>
              </div>
              <small>The file format should be JPEG or PDF</small>
            </div>
          </div>
          <div className={styles.buttonFlex}>
            <div className="mb-3 mr-4">
              <button className="btn btn-outline-danger mr-3 btn-filled-white">
                Previous
              </button>
            </div>
            {loading ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <>
                {showCertificateOfRegistration ? (
                  <button
                    type="submit"
                    className={`btn btn-danger btn-filled-red ${styles.filledSubmit}`}
                    onClick={submitOtherBusinessReferee}
                  >
                    Proceed
                  </button>
                ) : (
                  <button className={`${styles.submit}`}>Proceed</button>
                )}
              </>
            )}
          </div>
        </div>
      )}

      <div className=" card-form pl-1 pr-1 ">
        {main && (
          <>
            <div className="card-body">
              <h4 className="card-title text-center pl-3 mt-5">
                Add reference
              </h4>
              <p className={styles.paragraph}>
                Proceed to add two references, Kindly ensure that the referee’s
                account meets the following requirements:
              </p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>Account has been in operation for more than 6 months.</p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>Account is not dormant</p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>
                Category criteria (References from an individual account can
                only be used for an individual account but a reference from a
                registered business is suitable for all forms of current
                account).
              </p>
            </div>
            <div className={styles.alertBox}>
              <div className={styles.icon}>
                <img src={Icon_L} alt="" />
              </div>
              <div className={styles.textBox}>
                <div className={styles.text}>
                  <p>.</p>
                  <p className={styles.mainText}>
                    For referee with sterling account, an email is sent to the
                    referee to provide consent via a secured link.{" "}
                  </p>
                </div>
                <div className={styles.text}>
                  <p>.</p>
                  <p className={styles.mainText}>
                    For referee with other bank account, download or email form
                    to referee and upload the completed form.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {showReference && (
          <>
            {referenceSet ? (
              <div className={styles.references}>
                <h3>References</h3>
                <div className={styles.linkContainer}>
                  <div className={styles.link} onClick={addReference}>
                    Click to add references
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="form-group mt-4 mb-4">
                  <label className="label_text">Referee’s account number</label>
                  <input
                    className="form-control border-dark"
                    type="text"
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    placeholder="Enter your referee’s account number"
                  />
                </div>
                <div className="d-flex justify-content-end mt-4">
                  {loading ? (
                    <div className="spinner-border text-gold" role="status">
                      <span className="sr-only"></span>
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-danger btn-filled-red"
                      onClick={validateAccountNumber}
                    >
                      Validate
                    </button>
                  )}
                </div>
              </>
            )}
          </>
        )}

        {showBanks && (
          <div>
            <div className="form-group mt-4 mb-4">
              <label className="label_text">Referee’s account number</label>
              <input
                className="form-control border-dark"
                type="text"
                value={accountNumber}
                disabled
                placeholder="Enter your referee’s account number"
              />
            </div>
            <label className="label_text">Select Bank</label>
            <div className={styles.flexBoxes}>
              <div className={styles.box} onClick={clickSterlingBank}>
                Sterling bank
              </div>
              <div className={styles.box} onClick={clickOtherBanks}>
                Others bank
              </div>
            </div>
          </div>
        )}

        {showOtherBanks && (
          <div>
            <div className="card-body">
              <h4 className="card-title text-center pl-3 mt-5">
                Add reference
              </h4>
              <p className={styles.paragraph}>
                Proceed to add two references, Kindly ensure that the referee’s
                account meets the following requirements:
              </p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>Account has been in operation for more than 6 months.</p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>Account is not dormant</p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>
                Category criteria (References from an individual account can
                only be used for an individual account but a reference from a
                registered business is suitable for all forms of current
                account).
              </p>
            </div>
            <div className={styles.alertBox}>
              <div className={styles.icon}>
                <img src={Icon_L} alt="" />
              </div>
              <div className={styles.textBox}>
                <div className={styles.text}>
                  <p>.</p>
                  <p className={styles.mainText}>
                    For referee with sterling account, an email is sent to the
                    referee to provide consent via a secured link.{" "}
                  </p>
                </div>
                <div className={styles.text}>
                  <p>.</p>
                  <p className={styles.mainText}>
                    For referee with other bank account, download or email form
                    to referee and upload the completed form.
                  </p>
                </div>
              </div>
            </div>
            {goBack ? (
              <div>
                <div className="form-group mt-4 mb-4">
                  <label className="label_text">Referee’s account number</label>
                  <input
                    className="form-control border-dark"
                    type="text"
                    value={accountNumber}
                    disabled
                    placeholder="Enter your referee’s account number"
                  />
                </div>
                <label className="label_text">Select Bank</label>
                <div className={styles.flexBoxes}>
                  <div className={styles.box} onClick={clickSterlingBank}>
                    Sterling bank
                  </div>
                  <div className={styles.box} onClick={clickOtherBanks}>
                    Others bank
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="form-group mt-4 mb-4">
                  <label className="label_text">Referee’s account number</label>
                  <input
                    className="form-control border-dark"
                    type="text"
                    value={accountNumber}
                    placeholder="Enter your referee’s account number"
                  />
                </div>
                <div className={styles.showOtherBanksHeader}>
                  <label className="label_text">Select Bank</label>
                  <img src={dash} alt="" onClick={clickGoback} />
                </div>
                <div className="form-group mt-4 mb-4">
                  <label className="label_text">Select Other Bank</label>
                  <select
                    name="day"
                    value={otherBanks}
                    onChange={handleChange}
                    className="form-control bvn_inpu border-dark"
                    // placeholder="Select Referee's bank"
                  >
                    <option value='' disabled hidden>Select Referee's bank</option>
                    {banks.map((bank) => {
                      return (
                        <option key={bank.id} value={bank.name}>
                          {bank.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  {loading ? (
                    <div className="spinner-border text-gold" role="status">
                      <span className="sr-only"></span>
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-danger btn-filled-red"
                      onClick={proceedFromOtherBanks}
                    >
                      Proceed
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {refrenceAdded && (
          <div>
            <>
              <div className="card-body">
                <h4 className="card-title text-center pl-3 mt-5">
                  Add reference
                </h4>
                <p className={styles.paragraph}>
                  Proceed to add two references, Kindly ensure that the
                  referee’s account meets the following requirements:
                </p>
              </div>
              <div className={styles.flexInfo}>
                <img src={bullet} alt="" />
                <p>Account has been in operation for more than 6 months.</p>
              </div>
              <div className={styles.flexInfo}>
                <img src={bullet} alt="" />
                <p>Account is not dormant</p>
              </div>
              <div className={styles.flexInfo}>
                <img src={bullet} alt="" />
                <p>
                  Category criteria (References from an individual account can
                  only be used for an individual account but a reference from a
                  registered business is suitable for all forms of current
                  account).
                </p>
              </div>
              <div className={styles.alertBox}>
                <div className={styles.icon}>
                  <img src={Icon_L} alt="" />
                </div>
                <div className={styles.textBox}>
                  <div className={styles.text}>
                    <p>.</p>
                    <p className={styles.mainText}>
                      For referee with sterling account, an email is sent to the
                      referee to provide consent via a secured link.{" "}
                    </p>
                  </div>
                  <div className={styles.text}>
                    <p>.</p>
                    <p className={styles.mainText}>
                      For referee with other bank account, download or email
                      form to referee and upload the completed form.
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.referenceAdded}>
                <h3>References</h3>
                <div className={styles.referenceBox}>
                  <div className={styles.rheader}>
                    <p>1</p>
                    <div className={styles.linkContainer}>
                      <div className={styles.link} onClick={addReference}>
                        change reference
                      </div>
                    </div>
                  </div>
                  <div className={styles.referenceBoxBody}>
                    <p>{accountNumber}</p>
                    <p className={styles.sterling}>Alternative Bank</p>
                  </div>
                </div>
              </div>
              <hr />
              <div className={styles.linkContainer}>
                <div
                  className={styles.link}
                  onClick={clickShowSecondReferenceComponent}
                >
                  Click to add references
                </div>
              </div>
            </>
          </div>
        )}

        {sterlingBank && (
          <>
            <h4 className="card-title text-center pl-3 mt-5">Add reference</h4>
            <div className="form-group mt-4 mb-4">
              <label className="label_text">Referee’s account number</label>
              <input
                className="form-control border-dark"
                type="text"
                value={accountNumber}
                disabled
                placeholder="Enter your referee’s account number"
              />
            </div>
            <div className="form-group mt-4 mb-4">
              <label className="label_text">Select Bank</label>
              <input
                className="form-control border-dark"
                type="text"
                value={`Sterling Bank`}
                disabled
                placeholder="Enter your referee’s account number"
              />
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>Account has been in operation for more than 6 months.</p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>Account is not dormant</p>
            </div>
            <div className={styles.flexInfo}>
              <img src={bullet} alt="" />
              <p>
                Category criteria (References from an individual account can
                only be used for an individual account but a reference from a
                registered business is suitable for all forms of current
                account).
              </p>
            </div>
            <div className="d-flex justify-content-end mt-2">
              <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
                <button
                  className="btn btn-outline-danger mr-3 btn-filled-white"
                  onClick={changeReferee}
                >
                  Change referee
                </button>
              </div>
              {loading ? (
                <div className="spinner-border text-gold" role="status">
                  <span className="sr-only"></span>
                </div>
              ) : (
                <button
                  type="submit"
                  className="btn btn-danger btn-filled-red"
                  onClick={submitBusinessReferee}
                >
                  Proceed
                </button>
              )}
            </div>
          </>
        )}

        {secondReferenceComponenet && (
          <div>
            <>
              <div className="card-body">
                <h4 className="card-title text-center pl-3 mt-5">
                  Add reference
                </h4>
                <p className={styles.paragraph}>
                  Proceed to add two references, Kindly ensure that the
                  referee’s account meets the following requirements:
                </p>
              </div>
              <div className={styles.flexInfo}>
                <img src={bullet} alt="" />
                <p>Account has been in operation for more than 6 months.</p>
              </div>
              <div className={styles.flexInfo}>
                <img src={bullet} alt="" />
                <p>Account is not dormant</p>
              </div>
              <div className={styles.flexInfo}>
                <img src={bullet} alt="" />
                <p>
                  Category criteria (References from an individual account can
                  only be used for an individual account but a reference from a
                  registered business is suitable for all forms of current
                  account).
                </p>
              </div>
              <div className={styles.alertBox}>
                <div className={styles.icon}>
                  <img src={Icon_L} alt="" />
                </div>
                <div className={styles.textBox}>
                  <div className={styles.text}>
                    <p>.</p>
                    <p className={styles.mainText}>
                      For referee with sterling account, an email is sent to the
                      referee to provide consent via a secured link.{" "}
                    </p>
                  </div>
                  <div className={styles.text}>
                    <p>.</p>
                    <p className={styles.mainText}>
                      For referee with other bank account, download or email
                      form to referee and upload the completed form.
                    </p>
                  </div>
                </div>
              </div>
            </>
            {secondAccountNumberBanks ? (
              <>
                <div className="form-group mt-4 mb-4">
                  <label className="label_text">Referee’s account number</label>
                  <input
                    className="form-control border-dark"
                    type="text"
                    value={secondAccountNumber}
                    onChange={(e) => setSecondAccountNumber(e.target.value)}
                    placeholder="Enter your referee’s account number"
                  />
                </div>
                <div className="d-flex justify-content-end mt-4">
                  {loading ? (
                    <div className="spinner-border text-gold" role="status">
                      <span className="sr-only"></span>
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-danger btn-filled-red"
                      onClick={validateSecondAccountNumber}
                    >
                      Validate
                    </button>
                  )}
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="form-group mt-4 mb-4">
                    <label className="label_text">
                      Referee’s account number
                    </label>
                    <input
                      className="form-control border-dark"
                      type="text"
                      value={secondAccountNumber}
                      disabled
                      placeholder="Enter your referee’s account number"
                    />
                  </div>
                  <label className="label_text">Select Bank</label>
                  <div className={styles.flexBoxes}>
                    <div className={styles.box} onClick={clickSterlingBank}>
                      Sterling bank
                    </div>
                    <div className={styles.box} onClick={clickOtherBanks}>
                      Others bank
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        <hr />
      </div>
    </div>
  );
}
